// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import './LetterActionButtons.scss';

type Props = {
  id: string,
  onAskRemove: () => void,
};

const LetterActionButtons = ({ id, onAskRemove }: Props) => (
  <div className="LetterActionButtons">
    <Link to={`/write?edit_id=${id}&type=letter`} className="btn">
      수정
    </Link>
    <button className="btn" onClick={onAskRemove}>
      삭제
    </button>
  </div>
);

export default LetterActionButtons;



// WEBPACK FOOTER //
// ./src/components/letter/LetterActionButtons/LetterActionButtons.js